import React, {FC} from 'react';
import {useHistory, Switch, Route} from 'react-router-dom';

import {IDirectoryEntityMeta} from 'entities/metadata';
import {TEntity} from 'modules/data';
import {EEntityType} from 'shared/constants/entities';

import {FormEditModal} from '../../form-edit-modal/form-edit-modal';
import {DirectoryItemDescription} from './directory-item-description';

import './directory-item.less';

interface IDirectoryItemOwnProps {
    url: string;
    data: TEntity;
    metadata: IDirectoryEntityMeta;
    referenceUrl: string;
}

export const DirectoryItem: FC<IDirectoryItemOwnProps> = ({
    url,
    data,
    metadata,
    referenceUrl,
}: IDirectoryItemOwnProps) => {
    const history = useHistory();

    const handleClose = () => {
        history.go(-1);
    };

    return (
        <Switch>
            <div className="directory-item">
                <Route
                    path={url}
                    render={() => (
                        <DirectoryItemDescription
                            data={data}
                            metadata={metadata}
                        />

                    )}
                />
                <Route
                    path={`${url}/:id`}
                    render={() => (
                        <FormEditModal
                            entityName={metadata.name}
                            onClose={handleClose}
                            referenceUrl={referenceUrl}
                            resetEntityName={metadata.name}
                            resetEntityType={EEntityType.TABS}
                        />
                    )}
                />
            </div>
        </Switch>
    );
};
